/**
 * `Cell` content is a markdown-ish text blob where bullet lines look like
 * `"- some text\n- more text"`. This is a deliberately simple line-split, not
 * a full markdown renderer (see the matrix generation page design doc).
 *
 * Moved here from the frontend (`lib/cell-content.ts`) verbatim — the export
 * model builder (Task 3) needs the identical behavior, and there is no
 * reason to maintain two copies (2026-08-16 design doc, implementation note 5).
 *
 * Each line's bullet-or-not is tracked explicitly (point 7, 2026-08-18
 * matrix-view grill) — a bullet renders only for lines that literally start
 * with "- ", independent of how many lines the cell has (previously every
 * line got a bullet regardless).
 */
export interface BulletLine {
  text: string;
  hasBullet: boolean;
}

export function parseBulletLines(content: string): BulletLine[] {
  return content
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line) =>
      line.startsWith('- ')
        ? { text: line.slice(2), hasBullet: true }
        : { text: line, hasBullet: false },
    );
}
